import React, { type FC } from 'react'

import classes from './VideoThumbnail.module.scss'

type VideoThumbnailProps = {
  imgSrc: string
}

export const VideoThumbnail: FC<VideoThumbnailProps> = ({ imgSrc }) => {
  return (
    <div
      className={classes.Thumbnail}
      style={{ backgroundImage: `url(${imgSrc})` }}
    />
  )
}
